<template>
  <div>
    <div class="img-container about-us-top-img-container">
      <img alt="pic" src="~@/assets/images/about-us/banner.jpg" />
    </div>

    <!-- 下面会根据sort排序 所以采用 first second third命名， 组件名不具有实际意义 -->

    <CompanyProfile :loaded="loaded" :first="first" />

    <SalesNetwork :loaded="loaded" :second="second" />

    <History :loaded="loaded" :third="third" />

    <FactoryShow :loaded="loaded" :factories="factories" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import CompanyProfile from './about-us/CompanyProfile.vue';
import SalesNetwork from './about-us/SalesNetwork.vue';
import History from './about-us/History.vue';
import FactoryShow from './about-us/FactoryShow.vue';
import { getArticleListByTypes, getAllNewsList } from '@/api/apis';

export default defineComponent({
  name: 'AboutUs',
  components: {
    CompanyProfile,
    SalesNetwork,
    History,
    FactoryShow
  },
  created() {
    this.loadData();

    this.$bus.$on('calculate-img', this.calculateImg);
  },
  data() {
    return {
      first: {},
      second: {},
      third: {},
      factories: [],
      loaded: false
    };
  },
  mounted() {
    this.calculateImg();
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      this.loadData();
    }
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.about-us-top-img-container')
      );

      imgs.forEach(e => {
        e.style.height = `${window.innerWidth / 2.4}px`;
      });
    },
    async loadData() {
      const res = await Promise.all([
        getArticleListByTypes({
          types: [1, 2, 3].join(',')
        }),
        getAllNewsList()
      ]);

      if (res && res.length === 2 && res.every(s => s.success)) {
        const articles = res[0].result || [];

        this.first = articles[0];
        this.second = articles[1];
        this.third = articles[2];

        this.factories = res[1].result || [];
      }

      this.loaded = true;
    }
  }
});
</script>

<style lang="scss" scoped>
.img-container {
  img {
    height: 100%;
    width: 100%;
    display: inline-block;
  }
}
</style>
